module.exports = __webpack_public_path__ + "img/logoTS.4da8698c.svg";